export default {"src":"/_next/static/image/public/images/ic_whatsapp_green.d02415d075050b4530970d5eba6ede92.svg","height":30,"width":30};